export const fontSize1 = 11 * 1.3
export const fontSize2 = 12 * 1.3
export const fontSize3 = 13 * 1.3
export const fontSize4 = 14 * 1.3
export const fontSize5 = 16 * 1.3
export const fontSize6 = 18 * 1.3
export const fontSize7 = 19 * 1.15
export const fontSize8 = 70 * 1.2